import React, {Component} from "react";

import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";

import {withTranslation} from "react-i18next";

export class LoadDialog extends Component {
    onDone = () => {
        this.props.loadComplete(null);
        }

    onLoad = (e) => {
         var ret = JSON.parse(e.target.result);
         this.props.loadComplete(ret);
         }

    onChange = (e) => {
        e.target.files[0];
        var reader = new FileReader();
        reader.onload=this.onLoad;
        reader.readAsText(e.target.files[0]);
        e.preventDefault();
        }

    render = () => {
        const {t} = this.props;

        return <Dialog open={this.props.open}>
                <DialogTitle>{t("Load")}</DialogTitle>
                <DialogContent>
                    <form onSubmit={this.onSubmit}>
                        <input type="file" onChange={this.onChange}/>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="primary" onClick={this.onDone}>{t("Done")}</Button>
                </DialogActions>
            </Dialog>;
        }
    }

LoadDialog = withTranslation() (LoadDialog);
export default LoadDialog;